<template>
  <div class="searchActivity">
    <heads></heads>
    <div class="container">
      <div class="search-wrapper">
        <div class="search-input-wrapper">
          <input
            type="text"
            class="search-input"
            v-model="searchVal"
            @keyup.enter="toSearch"
            placeholder="请输入您想查找的内容"
          />
          <div class="search-btn" @click="tosearch">
            <span class="el-icon-search"></span>
            搜索
          </div>
        </div>
      </div>

      <div class="title" v-if="title">{{title}}</div>

      <div class="content" v-loading="loading">
        <div
          class="rotation-right"
          v-for="(item,index) in pageArray"
          :key="index"
          @click="toDetail(item.id)"
        >
        <div class="trans-img">
          <img :src="item.linePictureUrl" class="right-img" />
        </div>
          <div class="padd-info">
            <div class="right-infoitem">{{item.lineTitile}}</div>
            <div class="info-describe">{{item.lineAbstract}}</div>
            <div class="right-infobottom">
              <div class="right-price">￥{{item.price}}</div>
              <div>
                <span>{{fomateDate(item.date)}}</span>
                <span class="weeek" :class="colorClass(item.signUpStatus)">{{item.signUpStatus}}</span>
              </div>
            </div>
          </div>
        </div>

        <!--当长度余数为2、3的时候，填充布局-->
        <template v-if="afterLength">
          <div class="between-after" v-for="(item,index) in afterLength"></div>
        </template>

      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNumber"
          :page-size="12"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <homeFoots></homeFoots>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";
import { fomateDate } from "@/util/util.js";
import axios from "axios";
export default {
  name: "searchActivity",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      navArray: ["周边多天", "周边一天", "国内线路", "国外线路"],
      searchVal:'',
      styleId:'',
      pageArray: [],
      loading:false,
      title:""
    };
  },
  components: {
    heads,
    homeFoots,
    banners
  },
  computed: {
    afterLength() {
      //填充元素的长度
      const num = this.pageArray.length % 4;
      switch (num) {
        case 2:
        case 3:
          return 4 - num;
          break;
        default:
          return 0;
          break;
      }
    },
     colorClass(status){
      return function(status){
        switch (status) {
          case '报名中':
            return 'green'
            break;
          case '已成行':
            return 'orange'
            break;
          case '已满员':
            return 'red'
            break;
        }
      }
    }
  },
  methods: {
    fomateDate,
    handleCurrentChange(val) {
      this.pageArray=[]
      this.loading = true;
      this.getActivity()
    },
    handleSizeChange(val) {
    },
     toDetail(id) {
      this.$router.push({
        path: "/activityDetail",
        // query: { id: this.searchVal }
        query: { id: id}
      });
    },
    tosearch(){
      this.loading = true;
      this.getActivity()
    },
    getActivity() {
      const params = {
        pageNumber:this.pageNumber,
        pageSize: 12,
        keyWord: this.searchVal,
        lineStyle: this.styleId
      };

      axios
        .get(`/mobile/line/lineList.jhtml`, {
          params
        })
        .then(res => {
          if (res.data.success) {
            this.pageArray = res.data.returnValue.lineList;
            this.total = res.data.returnValue.total
          }
          this.loading = false;
        });
    }
  },
  mounted() {
    if (this.$route.query.search) {
      this.searchVal = this.$route.query.search;
    }else if(this.$route.query.id){
      this.styleId = this.$route.query.id;
    }

    this.title = this.$route.query.title;
    
    this.loading = true;
    this.getActivity();
  },
  created() {}
};
</script>

<style scoped>
.searchActivity {
  width: 100%;
  height: 100%;
  /* text-align: left; */
}
.container {
  text-align: left;
  margin-bottom: 20px;
}
.search-wrapper {
  width: 100%;
  /* position: absolute; */
  display: flex;
  justify-content: center;
  bottom: 0px;
  z-index: 9;
  box-sizing: border-box;
  color: #fff;
  font-size: 14px;
  padding: 20px 0;
  
  /* background: rgba(0, 0, 0, 0.38); */
}
.search-input-wrapper {
  display: flex;
  border-radius: 4px;
  padding: 5px;
  margin-top: 8px;
  position: relative;
  width: 800px;
  
}
.search-input {
  flex: 1;
  padding: 0 10px;
  /* border: 0; */
  border-radius: 4px;
  line-height: 45px;
  border: 1px solid #cccccc;
}
.search-btn {
  background: #007741;
  padding: 12px 25px;
  border-radius: 0 4px 4px 0;
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}
.search-btn:hover {
  background: #05a35c;
}
.search-radio {
  position: absolute;
  right: 120px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
}
.title {
  display: inline-block;
  margin: 20px 0;
  padding: 0 8px;
  color: #007741;
  border-bottom: 2px solid #007741;
  font-weight: bold;
  height: 30px;
  font-size: 16px;
  text-align: center;
  
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.textnav {
  display: flex;
  width: 100%;
  justify-content: space-around;
  height: 40px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  margin-top: 30px;
  padding: 0 240px;
  box-sizing: border-box;
}
.textnav > span {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}
.nac-active {
  color: #007741;
  font-weight: bold;
  border-bottom: 2px solid #007741;
}
.content {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;

  min-height: 300px;
  justify-content: space-between;
}
.rotation-left {
  position: relative;
  width: 65%;
  height: 420px;
  margin-bottom: 20px;
}

.label {
  padding: 6px 12px;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.8);
  line-height: 40px;
}
.label-text {
  height: 40px;
  line-height: 40px;
  border-top: 1px solid #ffffff;
}
.info-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}
.right-infobottom {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  font-size: 12px;
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  box-sizing: border-box;
}
.weeek {
  display: inline-block;
  margin-left: 8px;
  background: #007640;
  color: #fff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 12px;
  cursor: pointer;
}
.rotation-right {
  position: relative;
  width: 22%;
  height: 340px;
  background: #faf7f7;
  padding-bottom: 41px;
  box-sizing: border-box;
  cursor: pointer;
  margin-bottom: 10px;
  /* margin-right: 20px; */
}
.between-after {
  position: relative;
  width: 22%;
  height: 340px;
  padding-bottom: 41px;
  box-sizing: border-box;
  margin-bottom: 10px;
  /* margin-right: 20px; */
}
.rotation-right:hover .right-img{
  transform: scale(1.2);
}
.rotation-right:hover {
  box-shadow: 0px 0px 10px #aaaaaa;
}
.padd-info {
  padding: 0 6px;
  box-sizing: border-box;
}
.trans-img {
  width: 100%;
  height: 60%;
  overflow: hidden;
}
.right-img {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}
/* .right-img:hover {
  transform: scale(1.2);
} */
/* .right-img {
  width: 100%;
  height: 60%;
} */
.right-infoitem,
.info-describe {
  margin: 0 12px;
}
.right-infoitem {
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  height: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-top: 8px;
}
.info-describe {
  color: #676767;
  line-height: 22px;
  font-size: 14px;
  margin-top: 10px;
  height: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.right-price {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
}

.green {
  background: #007640;
}
.orange {
  background: #ff6c00;
}
.red {
  background: rgb(211, 23, 23);
}
</style>



// WEBPACK FOOTER //
// src/components/activityview/searchActivity.vue